var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{class:_vm.classP +
      (_vm.primary ? ' v-btn-primary ' : '') +
      (_vm.sutartis ? ' btn-sutartis ' : ''),attrs:{"color":_vm.color,"disabled":_vm.disabled,"loading":_vm.loading,"small":_vm.small,"x-small":_vm.xSmall}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }